<template lang="html">
  <div>
    <v-container class="hidden-md-and-up">
      <v-row>
        <v-col
          v-for="role in sortedRoles"
          :key="role.id"
          cols="12"
          md="4"
          xl="3"
        >        
          <v-card 
            class="elevation-10 pa-1" 
          >
            <v-list one-line>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium text-capitalize px-0">
                    {{ role.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text--primary">
                    Level {{ role.level }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider light />
            <v-card-actions>
              <setup-roles-dialog-edit
                v-if="$hasPermissionTo(['update roles'])"
                :role="role" 
                :type="type"
                @updated="getRoleList"
              /> 
              <span class="mx-1" />
              <setup-permissions-sidebar-form-edit   
                v-if="$hasPermissionTo(['update roles'])"
                :role="role" 
                :type="type"    
              />   
            </v-card-actions>
          </v-card>
        </v-col>      
      </v-row>  
    </v-container>
    <v-card class="elevation-10 hidden-sm-and-down">
      <v-toolbar
        flat
        color="white"
      >
        <v-toolbar-title> {{ type.toUpperCase()==="HRM"?'WORKSPACE':type.toUpperCase() }}  Roles</v-toolbar-title>
        <v-spacer />            
        <setup-roles-dialog-create
          v-if="$hasPermissionTo(['create roles'])"
          :type="type"
          @created="getRoleList"
        />
      </v-toolbar>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="roles"
        :sort-by.sync="sortBy"
        :items-per-page="itemsPerPage"
        item-key="id"
      >
        <template v-slot:item="props">
          <tr>
            <td>{{ props.item.level }}</td>
            <td>{{ props.item.name }}</td>
            <td>
              <setup-roles-dialog-edit
                v-if="$hasPermissionTo(['update roles'])"
                :role="props.item" 
                :type="type"
                @updated="getRoleList"
              /> 
              <span class="mx-1" />
              <setup-permissions-sidebar-form-edit   
                v-if="$hasPermissionTo(['update roles'])"
                :role="props.item" 
                :type="type"    
              />   
              <span class="mx-1" />
              <setup-roles-dialog-delete
                v-if="$hasPermissionTo(['delete roles'])"
                :role="props.item" 
                :type="type"
                @deleted="getRoleList"
              />
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
  export default {
    components: {
      SetupRolesDialogEdit: () => import('@/components/setup/roles/DialogEdit'),
      SetupRolesDialogDelete: () => import('@/components/setup/roles/DialogDelete'),
      SetupRolesDialogCreate: () => import('@/components/setup/roles/DialogCreate'),
      SetupPermissionsSidebarFormEdit: () => import('@/components/setup/permissions/SidebarFormEdit'),
    },
    props: {
      type: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        loading: false,
        headers: [
          {
            text: 'Rank',
            align: 'left',
            value: 'level',
          },
          {
            text: 'Role Name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Actions',
            sortable: false,
            value: '',
          },
        ],
        sortBy: 'level',
        itemsPerPage: 10,
        roles: [],
        selected: {},
        operators: {
          'asc': (levelA, levelB) => {
            return levelA - levelB 
          },
          'desc': (levelA, levelB) => {
            return levelB - levelA 
          },
        },
        orderBy: 'asc',
      }
    },
    computed: {    
      sortedRoles () {
        return [...this.roles].sort((a, b) => this.operators[this.orderBy](a.level, b.level))
      },
    },
    methods: {
      getRoleList () {
        this.loading = true

        this.$api.roles(this.type).list()
          .then((res) => {
            this.roles = res.data

            this.loading = false
          })
      },
    },
  }
</script>

<style scoped>
  ::v-deep .v-toolbar__content{
    margin-left:0px !important;
  }

  ::v-deep .v-table__overflow{
    overflow-x: hidden;
  }
</style>
